module.exports = __webpack_public_path__ + "assets/favicon-270.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon-270.png
// module id = 155
// module chunks = 0